import { useState } from 'react';
import styles from './index.module.css';

interface DownloadButtonProps {
  url: string;
  time: string;
}

function DownloadButton({ url, time }: DownloadButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const canShare = () => {
    return navigator.share !== undefined && navigator.canShare !== undefined;
  };

  const handleShare = async (event: any) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');

      const blob = await response.blob();
      const file = new File([blob], `replay-${time.replace(':', 'h')}.mp4`, { type: 'video/mp4' });

      // Verifica se pode compartilhar arquivos
      if (canShare() && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: `Replay ${time}`,
          text: 'Confira meu replay!'
        });
      } else {
        // Fallback: download tradicional
        downloadFile(blob);
      }
    } catch (error: any) {
      // Se usuário cancelou o share, não é erro
      if (error.name !== 'AbortError') {
        console.error('Failed to share file', error);
        // Tenta download como fallback
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          downloadFile(blob);
        } catch {
          console.error('Failed to download file');
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const downloadFile = (blob: Blob) => {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `replay-${time.replace(':', 'h')}.mp4`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  return (
    <button onClick={handleShare} className={styles.button} disabled={isLoading}>
      {isLoading ? 'Carregando...' : 'Compartilhar'}
    </button>
  );
}

export default DownloadButton;
